import { DesktopNavigation } from "./DesktopNavigation";
import { MobileNavigation } from "./MobileNavigation";
import { NavigationProps } from "./NavigationProps";
import { useState, useEffect } from "react";

export const Navigation = (props: NavigationProps) => {
  const [isOverFooter, setIsOverFooter] = useState(false);

  useEffect(() => {
    let ticking = false;

    const checkFooterPosition = () => {
      const footer = document.querySelector("footer");
      if (!footer) return;

      const footerRect = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Check if footer is visible in viewport and has reached the top portion
      // Footer is "under header" when its top edge is in the upper part of the viewport
      const isFooterVisible = footerRect.top < viewportHeight && footerRect.bottom > 0;
      const isFooterAtTop = footerRect.top <= 100; // Within 100px of top

      const shouldShowLightTheme = isFooterVisible && isFooterAtTop;


      setIsOverFooter(shouldShowLightTheme);
      ticking = false;
    };

    // Check on scroll with throttling
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(checkFooterPosition);
        ticking = true;
      }
    };

    // Initial check with a small delay to ensure DOM is ready
    const timeoutId = setTimeout(checkFooterPosition, 100);

    // Add scroll listener
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", checkFooterPosition);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkFooterPosition);
    };
  }, []);

  return (
    <div className="relative z-[100]">
      <div className="hidden dsk:block">
        <DesktopNavigation {...props} isOverFooter={isOverFooter} />
      </div>
      <div className="dsk:hidden">
        <MobileNavigation {...props} isOverFooter={isOverFooter} />
      </div>
    </div>
  );
};
